/**
 * Created by RKL on 07/09/2015.
 */
define('adminAssayDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'adminAssayDetailsView',
  'emptyView',
  'assayDetailTabController',
  'adminKitpController',
  'adminAnaAssayController',
  'rolesMixin',
  'settings',
  'entities/assay'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  assayDetailTabController,
  adminKitpController,
  adminAnaAssayController
) {
  'use strict';

  var AssaysDetailsController = {
    fetchAssay: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showAssay(data);
      } else {
        this.model = App.request('assay:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showAssay(data);
          }
        });
      }
    },

    showAssay: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'assay:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (assay) {
      this.view.onHeaderChange(assay);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      if (data.tab) {
        switch (data.tab.name) {
          case 'anaassay':
            adminAnaAssayController.showAnaAssayList(data);
            break;
          case 'kitp':
            adminKitpController.showKitpList(data);
            break;
          default:
            assayDetailTabController.showTab(data);
            break;
        }
      } else {
        assayDetailTabController.showTab(data);
      }

      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('admin/assays/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = AssaysDetailsController;
});
